import type { BorderSides } from '@/types';

export const ALL_SIDES: BorderSides = { top: true, right: true, bottom: true, left: true };
export const NO_SIDES: BorderSides = { top: false, right: false, bottom: false, left: false };

/**
 * Build CSS border-side properties for a rectangular element. When `sides` is
 * undefined every side is on (matches the legacy "full border" behavior).
 *
 * Width 0 or color empty short-circuits to no border on every side so that
 * callers can pass through their existing on/off flag without an outer guard.
 */
export function borderSidesCss(
  sides: BorderSides | undefined,
  width: number,
  color: string,
): React.CSSProperties {
  if (!width || !color) {
    return { borderTop: 'none', borderRight: 'none', borderBottom: 'none', borderLeft: 'none' };
  }
  const s = sides ?? ALL_SIDES;
  const stroke = `${width}px solid ${color}`;
  return {
    borderTop: s.top ? stroke : 'none',
    borderRight: s.right ? stroke : 'none',
    borderBottom: s.bottom ? stroke : 'none',
    borderLeft: s.left ? stroke : 'none',
  };
}
